export function loadCssOnce(href, id) {
	if (typeof document === 'undefined') return;
	const existing = id ? document.getElementById(id) : document.querySelector(`link[rel="stylesheet"][href="${href}"]`);
	if (existing) return existing;
	const link = document.createElement('link');
	link.rel = 'stylesheet';
	link.href = href;
	if (id) link.id = id;
	document.head.appendChild(link);
	return link;
}


